/**
 * Lightweight analytics helper.
 * - Toujours loggue dans la console (préfixe [analytics]) pour traçabilité runtime.
 * - Envoie à Plausible si window.plausible est défini (script chargé dans index.html).
 * - Tolérant aux erreurs : ne casse jamais le flux applicatif.
 */
type PlausibleFn = (event: string, options?: { props?: Record<string, string | number | boolean> }) => void;

declare global {
  interface Window {
    plausible?: PlausibleFn;
  }
}

export type AnalyticsProps = Record<string, string | number | boolean>;

export function trackEvent(event: string, props?: AnalyticsProps): void {
  try {
    // eslint-disable-next-line no-console
    console.info(`[analytics] ${event}`, props ?? {});
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible(event, props ? { props } : undefined);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("[analytics] tracking failed", error);
  }
}
